export var readIcon = "<svg width=\"9\" height=\"9\" viewBox=\"0 0 9 9\">\n<circle cx=\"4.00195\" cy=\"4.005\" r=\"4\"/>\n</svg>";
//# sourceMappingURL=read_icon.js.map